import type { ReactNode } from 'react'
import { PageHero } from './PageHero.js'

interface Props {
  title: string
  children: ReactNode
}

export function PageLayout({ title, children }: Props) {
  return (
    <>
      <PageHero title={title} />
      <main className="mx-auto max-w-[1180px] px-8 py-10 max-sm:p-4">{children}</main>
    </>
  )
}
